export default __webpack_public_path__ + "static/media/graph_placeholder.27f133e4.png";